// extracted by mini-css-extract-plugin
export default {"wrapper":"Callback_wrapper__VJF6K","container":"Callback_container__Ne6LO","heading":"Callback_heading__TMO32","subHeading":"Callback_subHeading__wVvPs"};